import { useState, useCallback } from 'react';
import quarkusApi from '../../../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

// Aplicações de um procedimento no mapa — URL base passada pelo componente.
export function useProcedureApplications(applicationsBaseUrl) {
  const [isLoading, setLoading] = useState(false);

  const fetchApplications = useCallback(() => {
    setLoading(true);
    return quarkusApi.get(applicationsBaseUrl, authHeader()).finally(() => setLoading(false));
  }, [applicationsBaseUrl]);

  const saveApplication = useCallback(
    (backendId, payload) => {
      setLoading(true);
      const request = backendId
        ? quarkusApi.put(`${applicationsBaseUrl}/${backendId}`, payload, authHeader())
        : quarkusApi.post(applicationsBaseUrl, payload, authHeader());
      return request.finally(() => setLoading(false));
    },
    [applicationsBaseUrl],
  );

  const deleteApplication = useCallback(
    (backendId) => {
      setLoading(true);
      return quarkusApi
        .delete(`${applicationsBaseUrl}/${backendId}`, authHeader())
        .finally(() => setLoading(false));
    },
    [applicationsBaseUrl],
  );

  return { fetchApplications, saveApplication, deleteApplication, isLoading };
}
